import api from './api';
import {
  getHDkey,
  getPrivateKey,
} from '@/js/modules/crypto.module';
import { Wallet, utils } from 'ethers';
import { auth } from '@/vuex/auth.module';
import { unlockSeed } from './sign-credentials.service';
// credentials: { login, password } typed in the confirmation
const ERC20TransactionConfirmation = async (txDetails, credentials) => {
  /**
   * @const decodedTx,
   * decoded tx to needed format for sign
   * NOTE: Buffer.from(buf.buffer) is unsafe - for buffers under ~4KB, Node/browser
   * buffer pooling means .buffer is the whole shared pool, not just this slice,
   * corrupting the decoded JSON. Use the buffer's own toString() instead.
   * */

  const decodedTx = Buffer.from(txDetails.tx, 'hex').toString();
  const seed = await unlockSeed(credentials);

  const hdKey = getHDkey(seed);
  const privateKey = getPrivateKey(hdKey);
  const txWithChainId = JSON.parse(decodedTx);
  /**
   * @const customTx,
   * refactor tx to needed structure for sign using sign method from ether-js lib
   * */
  const customTx = {
    type: null,
    chainId: txDetails.chain_id,
    to: txWithChainId.to,
    gasLimit: txWithChainId.gas,
    nonce: txWithChainId.nonce,
    gasPrice: txWithChainId.gasPrice,
    value: txWithChainId.value,
    data: txWithChainId.input,
  };
  /**
   * @const  walletPrivateKey,
   * create wallet private key using ether-js lib
   * */
  const walletPrivateKey = new Wallet(privateKey);
  /**
   * @const signedTx,
   * signed transaction using method from ether-js lib
   * */
  const signedTx = await walletPrivateKey.signTransaction(customTx);
  /**
   * forward signed transaction to back-end
   * */

  await api.post('/tx/v1/transactions', { tx: signedTx.slice(2) });

  return utils.parseTransaction(signedTx).hash;
};

/**
 * Broadcasting a tx only means the node accepted it into the mempool - it
 * says nothing about whether it actually succeeds once mined (see the
 * "не хватает баланса" purchase case, which returned 200 from /transactions
 * and still reverted on-chain). Poll the tx list for this hash's real
 * on-chain status before letting the caller report success.
 * Returns 'success' | 'failed' | 'timeout'.
 * */
export const waitForTxConfirmation = async (
  hash,
  wallet,
  { timeoutMs = 30000, intervalMs = 2000 } = {}
) => {
  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    const resp = await api.get('tx/v1/transactions', {
      params: {
        'filter[participant]': wallet,
        'page[limit]': 15,
        'page[order]': 'desc',
        'page[order_by]': 'id',
      },
    });
    const match = (resp.data?.data || []).find(
      (t) => t.hash?.toLowerCase() === hash.toLowerCase()
    );
    if (match) {
      if (match.status === 3) return 'success';
      if (match.status === 2) return 'failed';
      // status 1 = still pending, keep polling
    }
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }
  return 'timeout';
};

export default ERC20TransactionConfirmation;
